var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "var(--secondary-red-200)",
    width: 54,
    height: 54,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.25 11.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#DF4440",
    width: 31.5,
    height: 31.5,
    rx: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.55 19.5v.889c0 2.332-4.256 3.16-7.9 3.16-3.643 0-7.9-.828-7.9-3.16v-.89c1.766 1.084 4.456 1.682 7.9 1.682 3.445 0 6.135-.598 7.9-1.681zm0-4.74v.888c0 2.333-4.256 3.16-7.9 3.16-3.643 0-7.9-.827-7.9-3.16v-.889c1.766 1.083 4.456 1.68 7.9 1.68 3.445 0 6.135-.597 7.9-1.68zm-7.9-7.01c3.644 0 7.9.827 7.9 3.16 0 2.332-4.254 3.16-7.9 3.16-3.645 0-7.9-.828-7.9-3.16 0-2.333 4.257-3.16 7.9-3.16z",
    fill: "#FFFFFC"
  })))));
}
export default SvgDataset;